const CONVERSION_ID = 'AW-17703775825/cVEKCIDs6LkbENHc6PlB';

interface IReportConversionParams {
  url?: string;
  value?: number;
  currency?: string;
}

export const reportGoogleAdsConversion = ({
  url,
  value = 1,
  currency = 'KRW',
}: IReportConversionParams = {}): boolean => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    if (url) window.location.href = url;
    return false;
  }

  window.gtag('event', 'conversion', {
    send_to: CONVERSION_ID,
    value,
    currency,
    event_callback: () => {
      if (url) window.location.href = url;
    },
  });

  return false;
};
